import React from 'react';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { Box, Icon, Image, Set, Text, Tooltip } from 'bumbag';

import SheildLogo from 'pages/paymentmethods/assets/SheildLogo.svg';

function SecurityBox() {
  return (
    <Box backgroundColor="white800" padding="major-1" maxWidth="500px" marginBottom="major-3">
      <Set flexWrap="nowrap">
        <Image src={SheildLogo} height="50px" marginRight="major-1" />
        <Tooltip
          // @ts-expect-error
          content={
            <Box maxWidth="400px">
              <Text>
                Your card details will be securely stored with this business to enable them to charge you for products
                or services you may purchase from them at a future date. Please contact this business for any questions
                relating to how this business may use your saved card details.
              </Text>
            </Box>
          }
        >
          <Text>
            Enter your payment card details below to securely store them with this business.
            {/* @ts-expect-error TS(2322): Type 'IconDefinition' is not assignable to type 's... Remove this comment to see the full error message */}
            <Icon icon={faInfoCircle} type="font-awesome" color="primary" marginLeft="minor-1" />
          </Text>
        </Tooltip>
      </Set>
    </Box>
  );
}

export default SecurityBox;
